const LANGUAGE = {
  COPY_BE_KIND: "Be kind",
  COPY_VERSION: "Version",

  COPY_LOGIN_EMAIL: "Email",
  COPY_LOGIN_PASSWORD: "Password",

  COPY_PAYMENT_METHOD_ADD: "Payment Methods",

  COPY_SETTINGS_PROFILE: "Profile",
  COPY_SETTINGS_FREQUENTLY_ASKED_QUESTIONS: "Frequently Asked Questions",
  COPY_SETTINGS_LANGUAGE: "Language",
  COPY_SETTINGS_PAYMENTS: "Payments",
  COPY_SETTINGS_CURRENCY: "Currency",
  COPY_SETTINGS_TIMEZONE: "Timezone",
  COPY_SETTINGS_COUNTRY: "Country",
  COPY_SETTINGS_CONTACT_US: "Contact us",
  COPY_SETTINGS_LEGAL: "Legal",
  COPY_SETTINGS_PLAYGROUND: "Playground",
  COPY_SETTINGS_LOGOUT: "Logout",

  COPY_SEARCH_ORDER_BY:
    "Results are ordered by cost-effectiveness as determined by GiveWell.",

  COPY_SEARCH: "Search for charities, people or waterfalls",

  ORGANISATION_TAG__PEACE: "Peace",
  ORGANISATION_TAG__CHILDREN: "Children",
  ORGANISATION_TAG__ENVIRONMENT: "Environment",
  ORGANISATION_TAG__MENTAL_HEALTH: "Mental Health",
  ORGANISATION_TAG__WOMEN: "Women's Rights",
  ORGANISATION_TAG__SOCIAL_JUSTICE: "Social Justice",
  ORGANISATION_TAG__FOOD_AND_SHELTER: "Food & Shelter",
  ORGANISATION_TAG__MEDICAL_RESEARCH: "Medical Research",
  ORGANISATION_TAG__ANIMALS: "Animals",
  ORGANISATION_TAG__EDUCATION: "Education",

  COPY_READ_LESS: "Read less",
  COPY_READ_MORE: "Read more",

  COPY_VERSION_FREE: "The Emerald Version",
  COPY_VERSION_PREMIUM: "Raindrop Plus",

  COPY_FAQ_MONEY_QUESTION:
    "Does The Raindrop Company take a cut of my donation?",

  COPY_FAQ_MONEY_ANSWER:
    "No. The Raindrop Company does not take a cut of your donation.  You can be confident that 100% of your payment will go to the causes you choose to support.  Optionally, you can choose to be on Raindrop Plus where you'll use 10% of your payment to cover your transaction fees, remove advertisements and have access to all features.",

  COPY_FAQ_ONE_OFF_QUESTION: "Can I make a one-off donation?",
  COPY_FAQ_ONE_OFF_ANSWER:
    "No. The Raindrop Company supports monthly payments, but you can pause your payment at any time.",

  COPY_FAQ_STOP_DONATING_QUESTION: "Can I stop donating at anytime?",
  COPY_FAQ_STOP_DONATING_ANSWER:
    "Yes.  You can pause your payments at any time.",

  COPY_FAQ_RESTRICTED_QUESTION: "What is The Emerald Version?",
  COPY_FAQ_RESTRICTED_ANSWER:
    "The Emerald Version is a version of the app that does not require you to support The Raindrop Company, but you will see ads, you will be able to support fewer organisations simultaneously, you will not have access to badges and you will have a limited set of shareable content.  You will also have to pay a little more to cover your own transaction and foreign exchange fees.",

  COPY_FAQ_PREMIUM_QUESTION: "What is Raindrop Plus?",
  COPY_FAQ_PREMIUM_ANSWER:
    "Raindrop Plus is a version of the app without any advertisements, you can support the maximum of nine organisations and The Raindrop Company will cover all of your card transaction and foreign exchange fees.  You will also have access to badges and a full set of shareable content. You will be supporting The Raindrop Company with 10% of your payment.",

  COPY_HOME_ADD_A_NEW_ORGANISATION: "Add a new organisation",
  COPY_HOME_UNDO_DELETION: "Undo Deletion",

  ORGANISATION_STATUS_AWAITING_APPROVAL: "Awaiting Approval",
  ORGANISATION_STATUS_ACTIVE: "Active",
  ORGANISATION_STATUS_INACTIVE: "Inactive",

  ORGANISATION_TYPE__CHARITY: "Charity",
  ORGANISATION_TYPE__POLITICAL: "Political Party",
  ORGANISATION_TYPE__PERSON: "Person",
};

export default LANGUAGE;
